<template>
    <div id="header" >
        <div class="header">
            <div class="header-container">
                <img v-if="logo" class="logo" :src="logo" />
                <h5>{{ brand }}</h5>
                <div v-if="inWidget" class="closeWidget headerUtil" @click="closeWidget"></div>
                <div v-if="inWidget"
                    @click="toggleWidgetZoom"
                    :class="widgetZoom ? 'toggleWidgetZoom headerUtil active' : 'toggleWidgetZoom headerUtil'">
                </div>

                <textToSpeech 
                    v-if="isTextToSpeechAvailable"
                    :volume="1"
                    class="headerUtil"
                ></textToSpeech>

                <div v-if="menu.length > 0" class="menu"  @click="openMenu">
                    <ul class="menuList" v-show="showMenu">
                        <li v-for="(menuitem, index) in menu" :key="index">
                            <a v-if="menuitem.type == 'url'"
                                @click="closeMenu"
                                :href="menuitem.value"
                                target="_blank">
                                {{ menuitem.text }}
                            </a>
                            <hr v-if="menuitem.type == 'separator'" />
                            <a v-if="menuitem.type == 'action'"
                                class="button"
                                @click.stop="writeMessage(menuitem.value, menuitem.text)">
                                {{ menuitem.text}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <videoAvatar v-if="avatarvideo" :didBearer="didBearer"></videoAvatar>
    </div>
    
</template>

<script>
import textToSpeech from './TextToSpeech.vue'
import videoAvatar from './VideoAvatar.vue';

export default {
    name: 'chatheader',
    components: {
        textToSpeech,
        videoAvatar
    },
    props: {
        logo: String,
        brand: String,
        menu: Array,
        inWidget: Boolean,
        ttsEnabled: Boolean,
        avatarvideo: Boolean,
        didBearer: String
    },
    data() {
        return {
            showMenu: false,
            widgetZoom: false,
        }
    },
    methods: {
        closeWidget () {
            window.parent.postMessage({'message': 'maiaChatClose'}, '*')
        },
        toggleWidgetZoom () {
            if (this.widgetZoom) {
                window.parent.postMessage({'message': 'maiaChatSmallscreen'}, '*')
            } else {
                window.parent.postMessage({'message': 'maiaChatFullscreen'}, '*')
            }
            this.widgetZoom = !this.widgetZoom
        },
        openMenu () {
            this.showMenu = !this.showMenu
        },
        closeMenu () {
            this.showMenu = false
        },
        writeMessage (messageValue, messageText) {
            this.closeMenu()
            this.$root.$emit('send_message', messageValue, messageText)
        }
    },
    computed: {
        isTextToSpeechAvailable: function () {
            return this.ttsEnabled && Boolean(window.speechSynthesis);
        },
    }
};
</script>

<style lang="scss">
.header {
    position: relative;
    width: 100%;
    height: 75px;
    z-index: 99;
    padding: 18px 14px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    h5 {
        display: inline-block;
        line-height: 1.8em;
    }
    .header-container {
        max-width: 1000px;
        margin: 0 auto;
        &:after {
            display: table;
            content: "";
            clear: both;
        }
    }
    .logo {
        max-width: 40px;
        display: inline-block;
        border-radius: 50%;
        margin-right: 10px;
        vertical-align: middle;
        padding: 3px;
    }
    .closeWidget, .toggleWidgetZoom {
        float: right;
        position: relative;
        width: 29px;
        cursor: pointer;
        margin-left: 10px;
    }
    .closeWidget {
        background-image: url("/frontend/img/ico_close.svg");
    }
    .toggleWidgetZoom{
        background-image: url("/frontend/img/ico_zoom.svg");
        &.active{
            background-image: url("/frontend/img/ico_resize.svg");
        }
    }
    .headerUtil{
        width: 29px;
        text-align: center;
        height: 29px;
        background-color: #fff;
        padding-top: 1px;
        border-radius: 50%;
        background-size: 1em;
        background-repeat: no-repeat;
        background-position: center;
    }
    .menu {
        float: right;
        position: relative;
        background-color: transparent;
        background-image: url("/frontend/img/ico_menu.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 1.7em;
        height: 29px;
        width: 29px;
        cursor: pointer;
    }
    .menuList {
        position: absolute;
        background: #fff;
        color: #000;
        padding: 13px;
        list-style: none;
        top: 40px;
        right: 0;
        border-radius: 5px;
        box-shadow: 1px 1px 6px -2px rgba(0, 0, 0, 0.3);
        min-width: 180px;
        min-width: 200px;
        .button {
            margin: 0px;
            cursor: pointer;
            display: inline-block;
            cursor: pointer;
            &:hover{
                text-decoration: underline;
            }
        }
        hr {
            margin: 0.8rem -8px;
        }
    }
}
</style>